var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRollOfDumpsterTruck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 777 250",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "SKIP LOADER"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 148"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 145",
    transform: "translate(-1054.332 -6326.243)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 83.121,
    height: 33.49,
    fill: "var(--delivery-measurement-color)",
    "data-name": "Rectangle 1",
    rx: 10,
    transform: "translate(1148 6543)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-measurement-color)",
    d: "M133.529 209.25a2 2 0 0 1 3.4 0l6.914 11.194a2 2 0 0 1-1.7 3.051h-13.828a2 2 0 0 1-1.7-3.051Z",
    "data-name": "Polygon 6"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "ROLL OF DUMPSTER"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-12.5 -37.2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.9,
    cy: 5.9,
    r: 5.9,
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    "data-name": "Ellipse 23",
    transform: "translate(347.2 82.1)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "M571.8 185.2v-24.4",
    "data-name": "Line 54"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "M442.4 185.2h129.4v4.7a6.018 6.018 0 0 0 6 6h7.5",
    "data-name": "Path 76"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "M380 185.2h22",
    "data-name": "Line 55"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "M628.4 197.2H662a6.7 6.7 0 0 0 6.7-6.7v-45.6a12.5 12.5 0 0 0-1.8-6.5l-31.2-53a6.8 6.8 0 0 0-5.8-3.3h-51.5a6.7 6.7 0 0 0-6.7 6.7v78.7H319.5a4.8 4.8 0 0 0-4.8 4.8v8.1a4.8 4.8 0 0 0 4.8 4.8h20.1",
    "data-name": "Path 77"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.8,
    cy: 21.8,
    r: 21.8,
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    "data-name": "Ellipse 24",
    transform: "translate(585.2 171.6)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.8,
    cy: 21.8,
    r: 21.8,
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    "data-name": "Ellipse 25",
    transform: "translate(400.4 171.6)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.8,
    cy: 21.8,
    r: 21.8,
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    "data-name": "Ellipse 26",
    transform: "translate(338 171.6)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.7,
    cy: 11.7,
    r: 11.7,
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    "data-name": "Ellipse 27",
    transform: "translate(595.3 181.7)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.7,
    cy: 11.7,
    r: 11.7,
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    "data-name": "Ellipse 28",
    transform: "translate(410.5 181.7)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.7,
    cy: 11.7,
    r: 11.7,
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    "data-name": "Ellipse 29",
    transform: "translate(348.1 181.7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "M651.4 112.1H618a6.7 6.7 0 0 0-6.7 6.7v13.5a6.7 6.7 0 0 0 6.7 6.7h49.2",
    "data-name": "Path 78"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "M412.9 167.5 358.8 89",
    "data-name": "Line 56"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "m403 167.5-49.9-73.7",
    "data-name": "Line 57"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "m350.1 93-34.7 24a3.528 3.528 0 0 1-4.9-.9 3.528 3.528 0 0 1 .9-4.9l36.3-25.4",
    "data-name": "Path 79"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "M571.8 149.1H547a8.469 8.469 0 0 0-6.2 2.7l-14.3 15.7",
    "data-name": "Path 80"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "m540 152.6-43-14.3a3.213 3.213 0 0 0-4.1 2.1l-1.9 6.3a3.08 3.08 0 0 0 2.1 3.9l37.4 12.4",
    "data-name": "Path 81"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "m492.1 143.3-124.7-41.8",
    "data-name": "Line 58"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "M264.4 199.2v-67.7H37.1v67.7l16.8 16h193.9Z",
    "data-name": "Path 82"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "M381 198.4h20",
    "data-name": "Line 59"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.351,
    d: "M300.5 120.9c-2 6.8 7.2 7.6 6.1 1.6-.8-4.5 4.1-6.3 4.1-6.3",
    "data-name": "Path 83"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 53"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 52"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 1.676,
    d: "M257.5 125.7c.3-.5.5-1 .8-1.5",
    "data-name": "Path 84"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeDasharray: "3.523 3.523",
    strokeMiterlimit: 10,
    strokeWidth: 1.676,
    d: "M260.3 121.3a27.516 27.516 0 0 1 21.6-10.4 27.193 27.193 0 0 1 8.6 1.4",
    "data-name": "Path 85"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 1.676,
    d: "M292.1 112.9a10.093 10.093 0 0 1 1.5.7",
    "data-name": "Path 86"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 51"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m292.1 115.1 4.2-.1-2.3-3.6Z",
    "data-name": "Path 87"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 57"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 56"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M307.2 200.2h338.5",
    "data-name": "Line 60"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 54"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-color)",
    d: "m308.5 204.7-7.8-4.5 7.8-4.5Z",
    "data-name": "Path 88"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 55"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-color)",
    d: "m644.3 204.7 7.8-4.5-7.8-4.5Z",
    "data-name": "Path 89"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 61"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 60"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M36.3 200.2h203.2",
    "data-name": "Line 61"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-color)",
    d: "m37.6 204.7-7.8-4.5 7.8-4.5Z",
    "data-name": "Path 90"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 59"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-color)",
    d: "m238.2 204.7 7.7-4.5-7.7-4.5Z",
    "data-name": "Path 91"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 65"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 64"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M4.5 6.5v165.8",
    "data-name": "Line 62"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 62"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-color)",
    d: "M0 7.8 4.5 0 9 7.8Z",
    "data-name": "Path 92"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 63"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-color)",
    d: "m0 171 4.5 7.8L9 171Z",
    "data-name": "Path 93"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 69"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 68"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "m674.4 186 28.5-29.2",
    "data-name": "Line 63"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 66"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-color)",
    d: "m678.6 188.2-8.7 2.5 2.2-8.7Z",
    "data-name": "Path 94"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 67"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-color)",
    d: "m705.2 160.9 2.2-8.7-8.6 2.4Z",
    "data-name": "Path 95"
  }))))), /*#__PURE__*/React.createElement("text", {
    "data-name": "C,C m",
    fontFamily: "HKGrotesk-SemiBold, HK Grotesk",
    fontSize: 21.781,
    fontWeight: 600,
    transform: "translate(105.228 240.757)"
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "var(--delivery-measurement-inside-color)",
    x: 0,
    y: 0
  }, "C,C m")), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 149"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 145",
    transform: "translate(-700.332 -6326.243)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 83.121,
    height: 33.49,
    fill: "var(--delivery-measurement-color)",
    "data-name": "Rectangle 1",
    rx: 10,
    transform: "translate(1148 6543)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-measurement-color)",
    d: "M487.529 209.25a2 2 0 0 1 3.4 0l6.914 11.194a2 2 0 0 1-1.7 3.051h-13.828a2 2 0 0 1-1.7-3.051Z",
    "data-name": "Polygon 6"
  })), /*#__PURE__*/React.createElement("text", {
    "data-name": "L,L m",
    fontFamily: "HKGrotesk-SemiBold, HK Grotesk",
    fontSize: 21.781,
    fontWeight: 600,
    transform: "translate(459.228 240.757)"
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "var(--delivery-measurement-inside-color)",
    x: 0,
    y: 0
  }, "L,L m")), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 150"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "var(--delivery-measurement-color)",
    "data-name": "Group 125",
    transform: "translate(-453.8 -6362.233)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 83.121,
    height: 33.49,
    "data-name": "Rectangle 1",
    rx: 10,
    transform: "translate(1148 6543)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1170.814 6547.788a2 2 0 0 1 .802 2.204l-5.854 20.574a2 2 0 0 1-3.806.132l-11.848-32.568a2 2 0 0 1 3-2.344Z",
    "data-name": "Polygon 2"
  })), /*#__PURE__*/React.createElement("text", {
    "data-name": "W,W m",
    fontFamily: "HKGrotesk-SemiBold, HK Grotesk",
    fontSize: 21.781,
    fontWeight: 600,
    transform: "translate(702.2 204.767)"
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "var(--delivery-measurement-inside-color)",
    x: 0,
    y: 0
  }, "W,W m"))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 151"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "var(--delivery-measurement-color)",
    "data-name": "Group 124",
    transform: "translate(-1123.772 -6529.797)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 81,
    height: 33,
    "data-name": "Rectangle 1",
    rx: 10,
    transform: "translate(1148 6541)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.798 6556.71a2 2 0 0 1 2.204-.8l20.574 5.853a2 2 0 0 1 .132 3.806l-32.568 11.848a2 2 0 0 1-2.344-3Z",
    "data-name": "Polygon 2"
  })), /*#__PURE__*/React.createElement("text", {
    "data-name": "H,H m",
    fontFamily: "HKGrotesk-SemiBold, HK Grotesk",
    fontSize: 21.781,
    fontWeight: 600,
    transform: "translate(35.895 33.966)"
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "var(--delivery-measurement-inside-color)",
    x: 0,
    y: 0
  }, "H,H m"))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRollOfDumpsterTruck);
export default __webpack_public_path__ + "static/media/RollOfDumpsterTruck.248d838150dcfc43a35975f872b51574.svg";
export { ForwardRef as ReactComponent };